import { createAction, props } from '@ngrx/store';

import { IGuestCartResponse } from '../models/guest.models';

export const loadGuestCart = createAction(
  '[Guest Cart] Load Guest Cart',
  props<{guestUserId: string; guestCartId: string}>(),
);

export const loadGuestCartSuccess = createAction(
  '[Guest Cart] Load Guest Cart Success',
  props<{guestCartResponse: IGuestCartResponse}>(),
);

// Implement if custom error handling is needed (based on the clarification of error behaviour)
// export const loadGuestCartFail = createAction(
//   '[Guest Cart] Load Guest Cart Fail',
//   props<{error: string}>(),
// );
